/**
 * Query keys for min rep task owners. A pure module so cache invalidation can
 * import it without pulling in the Supabase client.
 */
export const representationTaskOwnerKeys = {
  all: ['representation-task-owners'] as const,
  forTasks: (taskIds: readonly string[]) =>
    [...representationTaskOwnerKeys.all, [...taskIds].sort((a, b) => a.localeCompare(b))] as const,
};

/** Query keys for min rep task stages (get_representation_task_stages). */
export const representationTaskStageKeys = {
  all: ['representation-task-stages'] as const,
  forTasks: (taskIds: readonly string[]) =>
    [...representationTaskStageKeys.all, [...taskIds].sort((a, b) => a.localeCompare(b))] as const,
};
